// Imports the necessary hooks and components from 'react-router-dom' for routing.
import { Routes, Route } from "react-router-dom";

// Imports custom components that represent different pages in the application.
import { MovieList, MovieDetail, Search, PageNotFound } from "../pages";

// Defines a functional component named `AllRoutes` that sets up the application's routing structure.
export const AllRoutes = () => {
  return (
    // Wraps the routing configuration in a div with a class that supports dark mode styling.
    <div className="dark:bg-darkbg">
        {/* The Routes component is the container for all Route components. It manages which component should be rendered based on the current URL path. */}
        <Routes>
            {/* Defines the default route ('/') to render the MovieList component for the homepage, displaying now playing movies. */}
            <Route path="" element={<MovieList apiPath="movie/now_playing" title="Home" />} />
            
            {/* Route for movie details page. It uses a dynamic segment (:id) to fetch and display details for a specific movie. */}
            <Route path="movie/:id" element={<MovieDetail />} />
            
            {/* Route for the popular movies page, rendering the MovieList component with a specific API path to fetch popular movies. */}
            <Route path="movies/popular" element={<MovieList apiPath="movie/popular" title="Popular" />} />
            
            {/* Route for the top rated movies page, rendering the MovieList component with an API path to fetch top-rated movies. */}
            <Route path="movies/top" element={<MovieList apiPath="movie/top_rated" title="Top Rated" />} />
            
            {/* Route for the upcoming movies page, rendering the MovieList component with an API path to fetch upcoming movies. */}
            <Route path="movies/upcoming" element={<MovieList apiPath="movie/upcoming" title="Upcoming" />} />
            
            {/* Route for the search page, allowing users to search for movies. It renders the Search component with an API path for searching movies. */}
            <Route path="search" element={<Search apiPath="search/movie" />} />
            
            {/* Catch-all route for undefined paths. It renders a PageNotFound component when the URL doesn't match any of the above routes. */}
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    </div>
  )
}
